import { get, postForm } from '@/utils/request';

/**
 * 每日故事|福利
 * @param {*} params
 * @param {*} params.userRole 角色类型
 * @param {*} params.currentDay 是否只要当天福利，1：是，0：默认所有
 * @returns
 */
export const getDailyBenefit = (params) => get('/v1/aichat/getDailyBenefit', params);

/**
 * 上传图片
 * @param {*} params
 * @param {*} params.file 文件
 * @param {*} params.type 上传业务类型：1，一键脱衣，2：一键跳舞页
 * @returns
 */
export const fileUpload = (params) => {
  const formData = new FormData();

  for (const key in params) {
    if (params[key] !== 'undefined' && typeof params[key] !== 'undefined') {
      formData.append(key, params[key]);
    }
  }

  return postForm('/v1/aichat/storage/fileUpload/new', formData);
};
